
























































  import { defineComponent, computed, PropType } from 'vue'
  import { Wishlist } from '@one/types/dist/orderpath/app'

  export default defineComponent({
    name: 'OneProductDropdownAddToWishlist',
    props: {
      wishlists: {
        type: Array as PropType<Wishlist.Responses.BasicWishlist[]>,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      progress: {
        type: Boolean,
        default: false,
      },
      productId: {
        type: String,
        required: true,
      },
    },
    emits: ['add-to-wishlist'],
    setup(props, { emit }) {
      const isDisabled = computed(() => props.progress || props.disabled)

      const onAddToWishlistClick = (wishlist?: Wishlist.Responses.BasicWishlist) => {
        emit('add-to-wishlist', wishlist)
      }

      return {
        isDisabled,
        onAddToWishlistClick,
      }
    },
  })
